<template>
    <div v-if="isPageReady" class="direct-eprescribe--wrapper">
        <common-content-wrapper width="small">
            <referrals-new-search-form
                ref="referralNewSearchForm"
                :practiceType="practiceType"
                :insurancePlans="insurancePlans"
                :specialities="specialities"
                :states="states"
                :facilityServices="facilityServices"
                @sent="showResults($event)"
            ></referrals-new-search-form>
        </common-content-wrapper>
        <common-buttons>
            <common-button
                v-if="referralType"
                :label="$t('common.microcopy.cancel')"
                type="link"
                size="large"
                @click="$emit('cancel')"
            ></common-button>
        </common-buttons>
        <common-modal v-if="showNoResultsModal" :width="'medium'" @close="closeMatchEprescribe">
            <header class="match-modal-header">
                <h4>{{ $t(`pages.eprescribe.eprescribe.no_match.${practiceType}`) }}</h4>
            </header>
            <div class="match-modal-footer">
                {{ $t('pages.referrals.new.steps.results.blank_slate.message') }}
                <common-button
                    :label="$t('pages.referrals.new.steps.results.blank_slate.link')"
                    type="link"
                    size="large"
                    @click="clearForm()"
                ></common-button>
            </div>
        </common-modal>
    </div>
</template>

<script>
    import ReferralsNewSearchForm from 'components/forms/ReferralsNewSearchForm'
    import FacilityServicesAPI from 'api/FacilityServicesAPI'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import PhysiciansAPI from 'api/PhysiciansAPI'

    export default {
        mixins: [PageWithDataMixin],

        components: {
            ReferralsNewSearchForm,
        },

        props: {
            practiceType: { type: String, required: true },
            referralType: { type: String, default: null },
            insurancePlans: { type: Array, required: true },
            specialities: { type: Array, required: true },
            facilityServices: { type: Array, required: true },
            states: { type: Array, required: true },
        },

        data() {
            return {
                showNoResultsModal: false,
            }
        },

        methods: {
            showResults(payload) {
                payload.practiceType = this.practiceType
                payload.referralType = this.referralType
                payload.practiceType === PracticeTypeEnum.PHYSICIAN
                    ? this.getPhysicanMatches(payload)
                    : this.getAncillaryMatches(payload)
            },

            clearForm() {
                this.showNoResultsModal = false
                this.$refs.referralNewSearchForm.resetComponentData()
                this.$refs.referralNewSearchForm.isSending = false
            },

            closeMatchEprescribe() {
                this.showNoResultsModal = false
                this.$refs.referralNewSearchForm.isSending = false
                this.$emit('cancel')
            },

            getPhysicanMatches(payload) {
                PhysiciansAPI.getMatchesList(payload).then((results) => {
                    if (!results.providers.length) {
                        this.showNoResultsModal = true
                        return
                    }
                    payload.matched = results.providers
                    this.$emit('add-eprescribe', payload)
                })
            },

            getAncillaryMatches(payload) {
                payload.testIds = payload.testIds.toString()
                FacilityServicesAPI.getMatchesList(payload).then((results) => {
                    if (!results.providers.length) {
                        this.showNoResultsModal = true
                        return
                    }
                    payload.matched = results.providers
                    payload.testIds = payload.testIds.split(',').map((item) => Number(item))
                    this.$emit('add-eprescribe', payload)
                })
            },
        },
    }
</script>

<style lang="scss">
    .match-modal-header {
        text-align: center;
        margin-bottom: 30px;
    }

    .match-modal-footer {
        text-align: center;
        font-size: 19px;

        button {
            font-size: 18px;
        }
    }
</style>
